import { useEffect } from "react";

const DEFAULT_TITLE = "Shonta Solutions LLC | Shared Housing in Central Florida";
const DEFAULT_DESC =
  "Shonta Solutions provides shared housing for adults in Central Florida, including the Orlando area. Private and shared bedrooms, housing referrals for caseworkers, and property partnerships.";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc = description || DEFAULT_DESC;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title || DEFAULT_TITLE);
    setMeta("property", "og:description", desc);
  }, [title, description]);

  return null;
}
